var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-container',[_c('v-row',{attrs:{"justify":"center"}},[_c('h2',[_vm._v("Sign in with Google")])]),_c('v-row',{attrs:{"justify":"center"}},[_c('div',{attrs:{"id":"signin_button"}})])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }